import { loadOrganizationDetails } from './check-auth';
import { permissionTypes } from 'drapcode-constant';
export const checkCodeExportPermission = () => {
  return checkPermission(permissionTypes.CODE_EXPORT);
};
export const checkDatabaseExportPermission = () => {
  return checkPermission(permissionTypes.DATABASE_EXPORT);
};
export const checkCollectionSnapPermission = () => {
  return checkPermission(permissionTypes.COLLECTION_SNAPSHOTS);
};
export const checkPageSnapPermission = () => {
  return checkPermission(permissionTypes.PAGE_SNAPSHOTS);
};
export const checkSnippetSnapPermission = () => {
  return checkPermission(permissionTypes.SNIPPET_SNAPSHOTS);
};
export const checkEncryptionPermission = () => {
  return checkPermission(permissionTypes.DATA_ENCRYPTION);
};
export const checkNotificationSettingPermission = () => {
  return checkPermission(permissionTypes.NOTIFICATION_SETTING);
};
export const checkSystemActivityPermission = () => {
  return checkPermission(permissionTypes.SYSTEM_ACTIVITY);
};
export const checkPWAPermission = () => {
  return checkPermission(permissionTypes.PWA_CONFIGURATION);
};
export const checkProfilerPermission = () => {
  return checkPermission(permissionTypes.PROFILER);
};
export const checkDeveloperAPIPermission = () => {
  return checkPermission(permissionTypes.DEVELOPER_API);
};
export const checkVersionPermission = () => {
  return checkPermission(permissionTypes.PROJECT_VERSION);
};
export const checkExternalAPIPermission = () => {
  return checkPermission(permissionTypes.EXTERNAL_API);
};
export const checkChatGPTPermission = () => {
  return checkPermission(permissionTypes.CHAT_GPT);
};
export const checkDataSourcePermission = () => {
  return checkPermission(permissionTypes.DATA_SOURCE);
};
export const checkCustomComponentPermission = () => {
  return checkPermission(permissionTypes.CUSTOM_COMPONENT);
};
const checkPermission = (code) => {
  console.log('code checking permission:>> ', code);
  const subscription = loadOrganizationDetails('subscription');
  console.log('my permission subscription :>> ', subscription);
  if (subscription === 'UNLIMITED') return true;
  console.log('No unlimited permission');
  const permissions = loadOrganizationDetails('permissions');
  if (!permissions) {
    console.log("I don't have any permission.");
    return true;
  }
  return permissions.includes(code);
};
